import { render, staticRenderFns } from "./UpdateDetailsPage.vue?vue&type=template&id=1ab0e5d6&scoped=true&"
import script from "./UpdateDetailsPage.vue?vue&type=script&lang=js&"
export * from "./UpdateDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0e5d6",
  null
  
)

export default component.exports